import { Text } from '@factorialco/deprecated-design-system'
import {
  TaxRateForSelectFragment,
  TaxRateSelectorDocument,
  TaxRateSelectorQuery,
} from 'generated/resources/graphql'

import { EntitySelector } from 'modules/core/components/EntitySelector'
import i18n from 'modules/core/lib/i18n'

import { TaxRateSelectorMultiProps, TaxRateSelectorProps } from './types'

function formatTaxRateName(taxRate?: TaxRateForSelectFragment) {
  if (!taxRate) return ''

  const factor = Math.pow(10, 2)
  const percentageRate = Math.round(taxRate.rate * 100 * factor) / factor

  return `${percentageRate}%`
}

export const TaxRateEntitySelector = (props: TaxRateSelectorProps | TaxRateSelectorMultiProps) => {
  const { readOnly, multiple, label, country, type, source } = props

  const variables = { country, type, source }

  const extractConnection = (data: TaxRateSelectorQuery) => {
    return data.finance.taxRatesConnection
  }

  const renderEntity = (entity: TaxRateForSelectFragment) => {
    return <Text.Normal>{formatTaxRateName(entity)}</Text.Normal>
  }

  const selectorConfig = {
    document: TaxRateSelectorDocument,
    extractConnection,
    label: label ?? i18n.t('finance.tax_rate.selector.label'),
    renderEntity,
    variables,
    disabled: readOnly,
  }

  if (multiple) {
    const selectorProps = { ...props, ...selectorConfig }

    return (
      <EntitySelector.Multiple
        {...selectorProps}
        renderValue={(taxRates) => (
          <Text.Normal ellipsis>
            {taxRates.length > 0
              ? taxRates.map((taxRate) => formatTaxRateName(taxRate)).join(', ')
              : i18n.t('common.select_multiple')}
          </Text.Normal>
        )}
      />
    )
  }

  const selectorProps = { ...props, ...selectorConfig }
  return (
    <EntitySelector
      {...selectorProps}
      renderValue={(taxRate) => (
        <Text.Normal ellipsis>
          {taxRate ? formatTaxRateName(taxRate) : i18n.t('common.select')}
        </Text.Normal>
      )}
      disabled={readOnly}
    />
  )
}
